module.exports = __webpack_public_path__ + "img/bg2.ff173a42.png";